import React from 'react';
import PropTypes from 'prop-types';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  FormGroup,
} from 'reactstrap';
import { useTranslation } from 'react-i18next';

const dropdownItemStyle = { boxSizing: 'border-box' };

const Selection = ({ type, data, value, valueKey, labelKey, ...props }) => {
  const { t } = useTranslation('app');
  function getDropdownToggleText() {
    if (value === '' || value === null || value === undefined) {
      return props.translate ? t(props.label) : props.label;
    }
    if (!props.includeZero && value === 0)
      return props.translate ? t(props.label) : props.label;
    const result = data.filter(
      (d) => d[valueKey].toString() === value.toString(),
    )[0];
    if (result) {
      if (props.translate) {
        return t(result[valueKey]);
      } else return result[valueKey];
    } else return props.translate ? t(props.label) : props.label;
  }
  function getDropdownLabel(item) {
    if (props.translate) {
      return t(item[labelKey]);
    } else return item[labelKey];
  }
  function handleItemClick(item) {
    props.onChange(item[valueKey]);
  }
  return (
    <FormGroup {...props.containerProps}>
      <Label {...props.labelProps}>{t(props.label)}</Label>
      <UncontrolledDropdown style={{ height: 36, ...props.toggleProps.style }}>
        <DropdownToggle
          caret
          style={{
            minWidth: 'auto',
            padding: 0,
            height: '100%',
            width: '100%',
          }}
        >
          {getDropdownToggleText()}
        </DropdownToggle>
        <DropdownMenu>
          {data.map((d, index) => {
            return (
              <React.Fragment key={index}>
                <DropdownItem
                  onClick={() => handleItemClick(d)}
                  style={{ ...dropdownItemStyle }}
                >
                  {getDropdownLabel(d)}
                </DropdownItem>
                {index !== data.length - 1 ? <DropdownItem divider /> : null}
              </React.Fragment>
            );
          })}
        </DropdownMenu>
      </UncontrolledDropdown>
    </FormGroup>
  );
};

Selection.defaultProps = {
  data: [],
  value: '',
  valueKey: 'value',
  labelKey: 'label',
  containerProps: {},
  labelProps: {},
  toogleProps: {},
};

Selection.propTypes = {
  data: PropTypes.array,
};

export default { Selection };
